(() => {
  if (customElements.get('coin-cart-recommendations')) return;
  customElements.define('coin-cart-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const priority = [...this.querySelectorAll('template[data-priority]')];
      const rest = [...this.querySelectorAll('template:not([data-priority])')];
      for (let i = rest.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [rest[i], rest[j]] = [rest[j], rest[i]];
      }
      const selected = [...priority, ...rest].slice(0, 2);
      this.querySelector('[data-recommendations]').replaceChildren(...selected.map(t => t.content.cloneNode(true)));
      this.hidden = selected.length === 0;
    }
  });
})();

(() => {
  if (customElements.get('coin-cart-goal')) return;
  const positions = new Map();
  customElements.define('coin-cart-goal', class extends HTMLElement {
    connectedCallback() {
      const target = Math.max(0, Math.min(100, Number(this.dataset.progress) || 0));
      const key = this.dataset.goalKey;
      const previous = positions.get(key) ?? 0;
      positions.set(key, target);
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const fill = this.querySelector('.coin-cart-goal__fill');
      const marker = this.querySelector('.coin-cart-goal__marker');
      if (!fill || !marker) return;
      const timing = { duration: 480, easing: 'cubic-bezier(.22, 1, .36, 1)' };
      fill.animate([{ width: previous + '%' }, { width: target + '%' }], timing);
      marker.animate([{ left: previous + '%' }, { left: target + '%' }], timing);
    }
    disconnectedCallback() {
      this.querySelectorAll('.coin-cart-goal__fill, .coin-cart-goal__marker').forEach(el => {
        el.getAnimations().forEach(animation => animation.cancel());
      });
    }
  });
})();
